import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Colors1 = function Colors1(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 20.4722C13.0615 21.4223 14.4633 22 16 22c3.3137 0 6-2.6863 6-6 0-2.7669-1.8729-5.0964-4.4202-5.7898m-11.1596 0C3.8729 10.9036 2 13.2331 2 16c0 3.3137 2.6863 6 6 6s6-2.6863 6-6c0-.7805-.149-1.5262-.4202-2.2102M18 8c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    })
  }));
};
export default Colors1;